module.exports = __webpack_public_path__ + "img/banner3.e0406f24.jpg";